import React from "react";
import DeviceUsers from "../modules/DeviceUsers/DeviceUsers";
export default function DeviceUsersPage() {
  return <DeviceUsers/>;
}
